export interface IOfferingServiceabilityRequest {
  doFetchFastWebTechnologyFlag?: boolean;
  serviceabilityAddress: {
    city: string;
    country: string;
    displayCountry: string;
    externalId: string;
    homeZone: string;
    istatCode: string;
    postalCode: string;
    stateOrProvince: string;
    displayStateOrProvince?: string;
    street: string;
    streetName: string;
    streetNumber: string;
  };
}

export interface IErrorInfo {
  code?: string;
  description?: string;
}

export interface IOfferingServiceabilityResponse {
  id: string;
  serviceabilityResult: string;
  offeringServiceabilityItem: IOfferingServiceabilityItem[];
  serviceabilityCharacteristic: IServiceabilityCharacteristic[];
  serviceabilityAddress: IServiceabilityAddress;
  errorinfo?: IErrorInfo;
  buildingNumberChecksum?: string;
}

export interface ILineSpeed {
  minimum: string;
  average: string;
  maximum: string;
}

export interface IProviderCoverageRetrieve {
  provider: string;
  technology: string;
  ratedDownloadSpeed: string;
  ratedUploadSpeed: string;
  lineSpeed: {
    upload: ILineSpeed;
    download: ILineSpeed;
  };
}

interface IOfferingServiceabilityItem {
  offering: IOffering;
}

interface IOffering {
  id: string;
  name: string;
}

export interface IServiceabilityCharacteristic {
  displayName: string;
  displayValue?: string;
}

export interface IServiceabilityAddress {
  city: string;
  country: string;
  displayCountry: string;
  postalCode: string;
  stateOrProvince: string;
  displayStateOrProvince?: string;
  street: string;
  externalId: string;
  streetNumber: string;
  homeZone: string;
  istatCode: string;
  districtCode?: string;
  latitude?: string;
  longitude?: string;
  streetName: string;
  streetType?: string;
  buildingNumber?: string;
  buildingLetter?: string;
  cityCode?: string;
  numericHouseNumber?: string;
}

export interface IBackupOffer {
  offering: {
    id: string;
    name: string;
  };
}

export interface ICharacteristic {
  displayName?: string;
  displayValue?: string;
}

export enum CoverageErrorType {
  KO,
  KO_FWA,
  FWA,
  R2_LOGGED,
  ERROR,
  MISSING_PARAMETERS_VALIDATE_ADDRESS_AMD_FW,
  NO_COVERAGE,
  NO_COVERAGE_AMD_FW,
  NO_COVERAGE_VODAFONE_ONLY_FW,
}

